const CODE_VERIFIER_LENGTH = 43;
const RANDOM_STRING_CHARACTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
const CODE_VERIFIER_STORAGE_KEY = 'codeVerifier';

const generateCodeChallenge = async (codeVerifier: string) => {
  const encoder = new TextEncoder();
  const data = encoder.encode(codeVerifier);
  const digest = await window.crypto.subtle.digest('SHA-256', data);

  return window
    .btoa(String.fromCharCode(...new Uint8Array(digest)))
    .replace(/=/g, '')
    .replace(/\+/g, '-')
    .replace(/\//g, '_');
};

const createRandomString = (length: number) => {
  const randomArray = new Uint8Array(length);
  crypto.getRandomValues(randomArray);

  return randomArray.reduce((result, number) => (
    result + RANDOM_STRING_CHARACTERS[number % RANDOM_STRING_CHARACTERS.length]
  ), '');
};

export const getCodeChallenge = () => {
  const codeVerifier = createRandomString(CODE_VERIFIER_LENGTH);
  sessionStorage.setItem(CODE_VERIFIER_STORAGE_KEY, codeVerifier);

  return generateCodeChallenge(codeVerifier);
};

export const getCodeVerifier = () => {
  const codeVerifier = sessionStorage.getItem(CODE_VERIFIER_STORAGE_KEY);
  sessionStorage.removeItem(CODE_VERIFIER_STORAGE_KEY);

  return codeVerifier;
};
